import React from 'react';
// import {Route, Link} from 'react-router-dom'
import ReactSVG from 'react-svg';
// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles';
import IconButton from '@material-ui/core/IconButton';
// import axios from 'axios'
// core components
import Header from 'components/Header/Header.jsx';
import HeaderLinks from 'components/Header/HeaderLinks.jsx';
// import Footer from "components/Footer/Footer.jsx";
import GridContainer from 'components/Grid/GridContainer.jsx';
import GridItem from 'components/Grid/GridItem.jsx';

import queryString from 'query-string';
// import jwt_decode from 'jwt-decode';
// import ModalComponent from './ModalComponent.jsx'
import { isEmpty } from 'validation/is-empty.js';
import loginPageStyle from 'assets/jss/material-kit-react/views/loginPage.jsx';
import { connect } from 'react-redux';
import {
  loginUser,
  setCurrentUser,
  logoutUser
} from 'redux/actions/authActions.js';
import setAuthToken from 'utils/setAuthToken.js';
// import bgImg from "../../assets/img/login/loginBg3.jpg";
import logo from '../../components/Icons/logo.svg';
import { history } from 'utils/hist';
import './LoginPage.css';

// const titleStyle = {fontFamily:'proba_pro_bold', fontSize: '1.3rem', padding: '8px 0'};
// const MyLink = props => <Link to="http://localhost:5000/api/users/auth" {...props} />
class LoginPage extends React.Component {
  constructor(props) {
    super(props);
    // we use this to make the card to appear after the page has been rendered
    this.state = {
      cardAnimaton: 'cardHidden',
      email: '',
      pass: '',
      open: false
    };
  }
  componentDidMount() {
    // we add a hidden class to the card and after 700 ms we delete it and the transition appears
    setTimeout(
      function() {
        this.setState({ cardAnimaton: '' });
      }.bind(this),
      700
    );

    var query = queryString.parse(this.props.location.search);
    //console.log(!isEmpty(query.token));
    if (!isEmpty(query.token)) {
      // const decoded = jwt_decode(query.token);
      localStorage.setItem('jwtToken', query.token);
      //this.props.setCurrentUser(decoded)
      setAuthToken(query.token);
      this.props.loginUser(query.token);
      history.push('/profile-page');
      // this.setState(state => {
      //   return {
      //     open: !state.open
      //   }
      // })
    } else {
      this.props.logoutUser();
    }
  }

  handleChange = event => {
    const { name, value } = event.target;
    this.setState({
      [name]: value
    });
  };
  render() {
    const { classes, ...rest } = this.props;
    return (
      <div>
        <Header
          absolute
          color="transparent"
          brand="EGAP"
          rightLinks={<HeaderLinks />}
          {...rest}
        />
        <div
          className={classes.pageHeader}
          style={{
            // background: "url(" + bgImg + ")",
            // backgroundSize: "cover",
            // backgroundPosition: "100% 65%",
            background: 'radial-gradient(#2D5CA6, #234161)'
          }}
        >
          <div className={classes.container}>
            <GridContainer justify="center" spacing={2} className="loginPage">
              <GridItem xs={12} sm={12} md={7} lg={6}>
                <GridContainer spacing={2}>
                  <GridItem xs={12} sm={12} md={12}>
                    {/* <h3 style={titleStyle}>ID.GOV.UA</h3> */}
                  </GridItem>
                </GridContainer>
                <GridContainer
                  justify="space-around"
                  spacing={0}
                  className="mb-3"
                >
                  <GridItem xs={12} sm={12} md={12} lg={12}>
                    <h3 className="text-center">
                      Інтегрована система електронної ідентифікації
                    </h3>
                    <div className="text-center mt-3 btnWrapper">
                      <IconButton
                        style={{ bodrerRadius: '0% !important' }}
                        className="ml-1 iconBtn"
                        // href="http://10.0.8.200:8080/mothers/generate"
                        //  href="http://10.0.8.176:8080/mothers/generate"
                        // href="http://10.0.8.108:8080/fop/generate"
                        //  href="https://dopomoga2fop.ioc.gov.ua/fop/generate"
                        href="/fop/generate"
                      >
                        <div>
                          {' '}
                          <ReactSVG
                            svgStyle={{ height: 43, marginTop: '3px' }}
                            src={logo}
                          />
                        </div>
                      </IconButton>
                    </div>
                  </GridItem>
                </GridContainer>
                {/* </CardBody>
                </Card> */}
              </GridItem>
            </GridContainer>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(null, { setCurrentUser, loginUser, logoutUser })(
  withStyles(loginPageStyle)(LoginPage)
);
